import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getExtStyles } from "@air/component-file-extension-preview";
import { formatBytes, formatDuration } from "@air/utilities";
import { memo } from "react";
import { useSelector } from "react-redux";
import { InfoPanelDetailsSection } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection";
import { InfoPanelDetailDescription } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/IntoPanelDetailDescription";
import { InfoPanelDetailTitle } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/IntoPanelDetailTitle";
import { centralizedClipDimensionsSelector, centralizedClipDurationSelector, centralizedClipExtSelector, centralizedClipSizeSelector } from "~/store/centralizedClip/selectors";
import { isStringMetadataType } from "~/utils/iptcDataTypes";
export const InfoPanelFileDetails = /*#__PURE__*/ memo((param)=>{
    let { clipMetadata } = param;
    const dimensions = useSelector(centralizedClipDimensionsSelector);
    const extension = useSelector(centralizedClipExtSelector);
    const duration = useSelector(centralizedClipDurationSelector);
    const size = useSelector(centralizedClipSizeSelector);
    const stats = [
        formatBytes(size)
    ];
    if (dimensions.width && dimensions.height) {
        stats.push("".concat(dimensions.width, " x ").concat(dimensions.height));
    }
    const videoFormat = clipMetadata === null || clipMetadata === void 0 ? void 0 : clipMetadata.find((metadata)=>metadata.fieldName === "VideoFieldOrder");
    const aspectRatio = clipMetadata === null || clipMetadata === void 0 ? void 0 : clipMetadata.find((metadata)=>metadata.fieldName === "VideoDisplayAspectRatio");
    const additionalStats = [];
    if (aspectRatio && isStringMetadataType(aspectRatio)) {
        additionalStats.push(aspectRatio.data);
    }
    if (videoFormat && isStringMetadataType(videoFormat)) {
        additionalStats.push(videoFormat.data);
    }
    const formattedDuration = duration ? formatDuration(duration) : null;
    const Icon = getExtStyles(extension).iconComponent;
    return /*#__PURE__*/ _jsxs(InfoPanelDetailsSection, {
        Icon: Icon,
        title: "Details",
        children: [
            !!extension && /*#__PURE__*/ _jsx(InfoPanelDetailTitle, {
                children: extension.toUpperCase()
            }),
            /*#__PURE__*/ _jsx(InfoPanelDetailDescription, {
                children: stats.join(", ")
            }),
            additionalStats.length > 0 && /*#__PURE__*/ _jsx(InfoPanelDetailDescription, {
                children: additionalStats.join(", ")
            }),
            !!formattedDuration && /*#__PURE__*/ _jsx(InfoPanelDetailDescription, {
                children: formattedDuration
            })
        ]
    });
});
InfoPanelFileDetails.displayName = "InfoPanelFileDetails";
